<div class="input-container">

  <app-svg-icon class="icon" [path]="'assets/icons/calendar_icon.svg'" />

  <input
    #visibleInput
    class="visible-input"
    [(ngModel)]="value"
    (input)="validateNow()"
    (dateTimeChange)="onDateChange($event)"
    [required]="required"
    [placeholder]="placeholder || defaultPlaceHolder"
    [disabled]="disabled"
    [readonly]="readonly"
    [owlDateTime]="dateTimePicker"
    [min]="computedMinDate"
    [max]="computedMaxDate"
    [ngClass]="{'form_error': hasError()}"
    [owlDateTimeTrigger]="dateTimePicker"
    [owlDateTimeFilter]="dateRangeFilter"
    #dateTime="ngModel"
  >

  <owl-date-time
    [pickerType]="DateTimeTypesVsPickerType[type]"
    [disabled]="disabled"
    [hour12Timer]="true"
    [startAt]="defaultStartAt"
    #dateTimePicker></owl-date-time>

  <!--  TODO: Format this html properly to get the min and max dates-->
  <!--  <div class="">-->
  <!--    <div *ngIf="dateTime.invalid && dateTime.errors.owlDateTimeMin">-->
  <!--      Date Time value must after {{ computedMinDate | date: 'medium' }}-->
  <!--    </div>-->
  <!--    <div *ngIf="dateTime.invalid && dateTime.errors.owlDateTimeMax">-->
  <!--      Date Time value must before {{ computedMaxDate | date: 'medium' }}-->
  <!--    </div>-->
  <!--  </div>-->


</div>

